import Tabs from "./Tabs";

export * from "./Tabs";
export * from "./Tab";
export * from "./types";

export default Tabs;
